import './scss/styles.scss';
import './home-counters';
import {addContainer, initStore, addLazyContainer} from '../utils/store';
import payment from './payment/reducers';
import {errors} from '../incab/common/reducers/errors';
import {reducer as currency} from '../currency/reducers';
import {default as demoBooking} from '../demo_new/reducers';

// Lazy load components that are not always needed
// PaymentForm is only needed on payment pages
addLazyContainer('PaymentForm', () => import(/* webpackChunkName: "payment" */ './payment/components/PaymentForm'));

// BaseCourseVideo is only needed on course pages with video
addLazyContainer('BaseCourseVideo', () => import(/* webpackChunkName: "base-course-video" */ './common/components/BaseCourseVideo'));


initStore({
    payment,
    errors,
    currency,
    demoBooking,
}, window.INITIAL_STATE);

// Wait for jQuery to be available before using it
(function waitForJQuery() {
    if (typeof window.jQuery !== 'undefined' || typeof window.$ !== 'undefined') {
        const $ = window.jQuery || window.$;
        $(document).ready(function () {
    // Initialize Swiper only if it's available and elements exist
    let swiperRetryCount = 0;
    const MAX_SWIPER_RETRIES = 50; // Retry for up to 5 seconds (50 * 100ms)

    function initSwipers() {
        // Check if Swiper elements exist
        const swiperElements = $('.swiper-langs');
        if (swiperElements.length === 0) {
            // No Swiper elements on this page, nothing to initialize
            return;
        }
        
        if (typeof Swiper === 'undefined') {
            // Swiper not loaded yet, retry with exponential backoff
            swiperRetryCount++;
            if (swiperRetryCount < MAX_SWIPER_RETRIES) {
                setTimeout(initSwipers, 100);
            } else {
                console.warn('Swiper library failed to load after', MAX_SWIPER_RETRIES, 'retries');
            }
            return;
        }

        // Swiper is loaded, initialize all swiper elements
        swiperElements.each(function (index, item) {
            if (!$(item).data('swiper-initialized')) {
                try {
                    new Swiper(item, {
                        direction: 'horizontal',
                        slidesPerView: 'auto',
                        initialSlide: $(item).find('.active').index(),
                        prevButton: $(item).parents('.swiper-langs-wrapper').find('.lang-button-prev')[0],
                        nextButton: $(item).parents('.swiper-langs-wrapper').find('.lang-button-next')[0],
                        roundLengths: true,
                    });
                    $(item).data('swiper-initialized', true);
                } catch (error) {
                    console.error('Error initializing Swiper:', error);
                }
            }
        });
    }

    // Start initialization
    initSwipers();

        // Throttle function to prevent forced reflows
        function throttle(func, wait) {
            let timeout;
            return function() {
                const context = this;
                const args = arguments;
                if (!timeout) {
                    timeout = setTimeout(function() {
                        timeout = null;
                        func.apply(context, args);
                    }, wait);
                }
            };
        }

        // Use requestAnimationFrame for scroll events to batch layout reads
        let rafId = null;
        function checkInViewElements() {
            $('.watch-inview').each((i, el) => {
                if (isElementInViewport(el)) {
                    if (!$(el).hasClass('inview')) {
                        $(el).addClass('inview');
                        $(el).trigger('inview');
                    }
                }
            });
            rafId = null;
        }

        function scheduleInViewCheck() {
            if (rafId === null) {
                rafId = requestAnimationFrame(checkInViewElements);
            }
        }

        // Check elements in viewport BEFORE adding body.loaded class
        // This ensures they get the inview class before CSS makes them invisible
        checkInViewElements();

        // Now add loaded class - elements already marked as inview will remain visible
        $('body').addClass('loaded');

        // Double-check after loaded class is added to catch any elements that might have been missed
        // Use requestAnimationFrame to ensure CSS has been applied
        requestAnimationFrame(function() {
            checkInViewElements();
        });

        // Throttle scroll and resize events to prevent forced reflows
        $(document).on('scroll resize', throttle(function() {
            scheduleInViewCheck();
        }, 16));

        $('.scroll').on('click', function (e) {
            const wrapper = $('body');
            const hashIndex = $(this).attr('href').indexOf('#');
            if (hashIndex == -1) {
                return;
            }
            wrapper.animate({
                scrollTop: $($(this).attr('href').substring(hashIndex)).offset().top,
            }, 400);
        });

        function isElementInViewport(el) {
            return $(el)[0].getBoundingClientRect().top < window.innerHeight;
        }

        // Reviews carousel navigation
        // Removed initReviewsCarousel() - "Ваши результаты" block was removed

        // Initialize client reviews carousel
        function initClientReviewsCarousel() {
            const $clientReviewsSection = $('#client-reviews');
            if ($clientReviewsSection.length === 0) {
                return;
            }

            // Extract reviews data
            const reviews = [];
            $clientReviewsSection.find('.client-review-item').each(function() {
                const $item = $(this);
                reviews.push({
                    photo: $item.find('.client-review-photo-url').text().trim(),
                    text: $item.find('.client-review-text').html(),
                    name: $item.find('.client-review-name').text().trim(),
                    url: $item.find('.client-review-url').text().trim()
                });
            });

            if (reviews.length === 0) {
                return;
            }

            const $carousel = $clientReviewsSection.find('.client-reviews-carousel');
            const $content = $carousel.find('.client-reviews-carousel__content');
            const $dots = $carousel.find('.client-reviews-carousel__dot');
            const $prevBtn = $carousel.find('.client-reviews-carousel__btn--prev');
            const $nextBtn = $carousel.find('.client-reviews-carousel__btn--next');

            let currentIndex = 0;
            let isTransitioning = false;
            const TRANSITION_DURATION = 300;

            // Create review card HTML
            function createReviewCard(review, index) {
                const authorHtml = review.url
                    ? `<a href="${review.url}" target="_blank" rel="noopener noreferrer" class="card-link"><strong>${review.name}</strong></a>`
                    : `<strong class="card-text">${review.name}</strong>`;

                return `
                    <div class="client-review-card"
                         id="client-review-${index}"
                         data-index="${index}">
                        <div class="card shadow-sm">
                            <div class="card-body d-flex flex-column">
                                <div class="mb-3 text-center">
                                    <img src="${review.photo}"
                                         alt="${review.name}"
                                         class="rounded-circle img-fluid"
                                         width="100"
                                         height="100"
                                         loading="lazy">
                                </div>
                                <div class="card-text flex-grow-1 mb-3">
                                    ${review.text}
                                </div>
                                <div class="mt-auto">
                                    ${authorHtml}
                                </div>
                            </div>
                        </div>
                    </div>
                `;
            }

            // Update active state
            function updateActiveState(index) {
                // Update dots
                $dots
                    .removeClass('client-reviews-carousel__dot--active')
                    .attr('aria-selected', 'false')
                    .attr('tabindex', '-1');
                $dots.eq(index)
                    .addClass('client-reviews-carousel__dot--active')
                    .attr('aria-selected', 'true')
                    .attr('tabindex', '0');

                // Update review cards
                $content.find('.client-review-card')
                    .removeClass('client-review-card--active')
                    .attr('aria-hidden', 'true');
                $content.find(`#client-review-${index}`)
                    .addClass('client-review-card--active')
                    .attr('aria-hidden', 'false');
            }

            // Navigate to specific review
            function goToReview(index) {
                if (isTransitioning || index === currentIndex || index < 0 || index >= reviews.length) {
                    return;
                }

                isTransitioning = true;
                const review = reviews[index];

                // Create new card if it doesn't exist
                let $newCard = $content.find(`#client-review-${index}`);
                if ($newCard.length === 0) {
                    $newCard = $(createReviewCard(review, index));
                    $content.append($newCard);
                } else {
                    // Remove hidden class if it exists
                    $newCard.removeClass('client-review-card--hidden');
                }

                // Update active state
                updateActiveState(index);
                currentIndex = index;

                // Reset transition flag after animation
                setTimeout(() => {
                    isTransitioning = false;
                }, TRANSITION_DURATION);
            }

            // Navigate to next review
            function nextReview() {
                const nextIndex = (currentIndex + 1) % reviews.length;
                goToReview(nextIndex);
            }

            // Navigate to previous review
            function prevReview() {
                const prevIndex = (currentIndex + reviews.length - 1) % reviews.length;
                goToReview(prevIndex);
            }

            // Initialize all review cards
            reviews.forEach((review, index) => {
                if (index === 0) {
                    // First review is already in HTML, ensure it has correct attributes
                    const $existingCard = $content.find('.client-review-card');
                    if ($existingCard.length) {
                        $existingCard.attr('id', 'client-review-0')
                            .attr('data-index', '0')
                            .attr('aria-hidden', 'false');
                    }
                } else {
                    // Create other cards but keep them hidden
                    const $card = $(createReviewCard(review, index));
                    $card.addClass('client-review-card--hidden').attr('aria-hidden', 'true');
                    $content.append($card);
                }
            });

            // Initialize active state
            updateActiveState(0);

            // Event handlers
            $prevBtn.on('click', function(e) {
                e.preventDefault();
                prevReview();
            });

            $nextBtn.on('click', function(e) {
                e.preventDefault();
                nextReview();
            });

            // Dot click
            $dots.on('click', function() {
                const index = parseInt($(this).attr('data-index'), 10);
                if (!isNaN(index)) {
                    goToReview(index);
                }
            });

            // Keyboard navigation
            $carousel.on('keydown', function(e) {
                if (e.target.classList.contains('client-reviews-carousel__dot')) {
                    if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        prevReview();
                    } else if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        nextReview();
                    } else if (e.key === 'Home') {
                        e.preventDefault();
                        goToReview(0);
                    } else if (e.key === 'End') {
                        e.preventDefault();
                        goToReview(reviews.length - 1);
                    }
                }
            });

            // Swipe support for touch devices
            let touchStartX = 0;
            let touchEndX = 0;

            $carousel.on('touchstart', function(e) {
                touchStartX = e.originalEvent.touches[0].clientX;
            });

            $carousel.on('touchend', function(e) {
                touchEndX = e.originalEvent.changedTouches[0].clientX;
                handleSwipe();
            });

            function handleSwipe() {
                const swipeThreshold = 50;
                const diff = touchStartX - touchEndX;

                if (Math.abs(diff) > swipeThreshold) {
                    if (diff > 0) {
                        nextReview();
                    } else {
                        prevReview();
                    }
                }
            }
        }

        initClientReviewsCarousel();

        // Initialize Reviews Carousel with Bootstrap Nav
        function initReviewsCarousel() {
            const $reviewsSection = $('#reviews-carousel-section');
            if ($reviewsSection.length === 0) {
                return;
            }

            // Extract reviews data
            const reviews = [];
            $reviewsSection.find('.review-item').each(function() {
                const $item = $(this);
                reviews.push({
                    photo: $item.find('.review-photo-url').text().trim(),
                    text: $item.find('.review-text').html(),
                    name: $item.find('.review-name').text().trim(),
                    url: $item.find('.review-url').text().trim()
                });
            });

            if (reviews.length === 0) {
                return;
            }

            const $content = $reviewsSection.find('.reviews-carousel__content');
            const $navLinks = $reviewsSection.find('.nav-link');
            let currentIndex = 0;

            // Create review card HTML
            function createReviewCard(review, index) {
                const authorHtml = review.url
                    ? `<a href="${review.url}" target="_blank" rel="noopener noreferrer" class="card-link">${review.name}</a>`
                    : `<span>${review.name}</span>`;

                return `
                    <div class="review-card"
                         id="review-${index}"
                         data-index="${index}">
                        <div class="mb-3">
                            ${review.text}
                        </div>
                        <div>
                            ${authorHtml}
                        </div>
                    </div>
                `;
            }

            // Update active state
            function updateActiveState(index) {
                // Update nav links (Bootstrap active class)
                $navLinks
                    .removeClass('active')
                    .attr('aria-selected', 'false')
                    .attr('tabindex', '-1');
                $navLinks.eq(index)
                    .addClass('active')
                    .attr('aria-selected', 'true')
                    .attr('tabindex', '0');

                // Update review cards
                $content.find('.review-card')
                    .removeClass('review-card--active')
                    .attr('aria-hidden', 'true');
                $content.find(`#review-${index}`)
                    .addClass('review-card--active')
                    .attr('aria-hidden', 'false');
            }

            // Navigate to specific review
            function goToReview(index) {
                if (index === currentIndex || index < 0 || index >= reviews.length) {
                    return;
                }

                const review = reviews[index];

                // Create new card if it doesn't exist
                let $newCard = $content.find(`#review-${index}`);
                if ($newCard.length === 0) {
                    $newCard = $(createReviewCard(review, index));
                    $content.append($newCard);
                }

                // Update active state
                updateActiveState(index);
                currentIndex = index;
            }

            // Initialize all review cards
            reviews.forEach((review, index) => {
                if (index === 0) {
                    // First review is already in HTML, ensure it has correct attributes
                    const $existingCard = $content.find('.review-card');
                    if ($existingCard.length) {
                        $existingCard.attr('id', 'review-0')
                            .attr('data-index', '0')
                            .attr('aria-hidden', 'false');
                    }
                } else {
                    // Create other cards but keep them hidden
                    const $card = $(createReviewCard(review, index));
                    $card.addClass('d-none').attr('aria-hidden', 'true');
                    $content.append($card);
                }
            });

            // Initialize active state
            updateActiveState(0);

            // Nav link click handler
            $navLinks.on('click', function(e) {
                e.preventDefault();
                const index = parseInt($(this).attr('data-index'), 10);
                if (!isNaN(index)) {
                    goToReview(index);
                }
            });

            // Keyboard navigation
            $reviewsSection.on('keydown', function(e) {
                if (e.target.classList.contains('nav-link')) {
                    if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        const prevIndex = (currentIndex + reviews.length - 1) % reviews.length;
                        goToReview(prevIndex);
                    } else if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        const nextIndex = (currentIndex + 1) % reviews.length;
                        goToReview(nextIndex);
                    } else if (e.key === 'Home') {
                        e.preventDefault();
                        goToReview(0);
                    } else if (e.key === 'End') {
                        e.preventDefault();
                        goToReview(reviews.length - 1);
                    }
                }
            });
        }

        initReviewsCarousel();
    });
    } else {
        // jQuery not loaded yet, retry after a short delay
        setTimeout(waitForJQuery, 50);
    }
})();



// WEBPACK FOOTER //
// ./src/portal/app.js